import { render, staticRenderFns } from "./enterInfo.vue?vue&type=template&id=23ff7ec9&scoped=true"
import script from "./enterInfo.vue?vue&type=script&lang=js"
export * from "./enterInfo.vue?vue&type=script&lang=js"
import style0 from "./enterInfo.vue?vue&type=style&index=0&id=23ff7ec9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ff7ec9",
  null
  
)

export default component.exports